import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { UserContext } from '../context/UserContext';
import '../App.css';

const Login = () => {
  const navigate = useNavigate();
  const { setUsuario, setRol } = useContext(UserContext);
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const credenciales = await signInWithEmailAndPassword(auth, email, clave);
      const userDoc = await getDoc(doc(db, 'usuarios', credenciales.user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        setUsuario(credenciales.user);
        setRol(data.rol); // <- asegurarse que el campo se llame "role" en Firestore
        navigate('/');
      } else {
        setError('Usuario sin rol asignado.');
      }
    } catch (err) {
      console.error('Error al iniciar sesión:', err);
      setError('Credenciales incorrectas');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleLogin} className="login-form">
        <h2 className="login-title">Frenos & Multiservicios GLOBAL</h2>
        <p className="login-subtitle">Iniciar Sesión</p>
        {error && <p className="login-error">{error}</p>}

        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
          required
        />
        <button type="submit" className="btn-login">Ingresar</button>

        <p className="login-subtext">
          ¿No tienes cuenta? Pídele a un <strong>administrador</strong> que te registre.
        </p>
      </form>
    </div>
  );
};

export default Login;
